// extracted by mini-css-extract-plugin
export var DisabledMinus = "CardNumericGroup-module--DisabledMinus--90c1a";
export var DisabledPlus = "CardNumericGroup-module--DisabledPlus--1ecfa";
export var ModifierActionsWrapper = "CardNumericGroup-module--ModifierActionsWrapper--8a92c";
export var NumericInputWrapper = "CardNumericGroup-module--NumericInputWrapper--c4f50";
export var RTL = "CardNumericGroup-module--RTL--f9a81";
export var SmallQuantityInputWrapper = "CardNumericGroup-module--SmallQuantityInputWrapper--f45e8";